// Triggers a browser download for a base64 payload returned by the API.
//
// Endpoints that hand back a generated file (tasks#chatbot_pdf, team_profiles#resume_pdf)
// return { blob, filename } as JSON rather than a file response, because the api client
// always attaches a bearer token and so the browser can't just navigate to the URL.
//
// Distinct from common/FileDownloadHelper, which takes a raw axios response body rather than
// a base64 string. Worth folding together, but that helper backs the Leaderboard CSV export
// and rewiring it isn't in this change's scope.
export function base64ToUint8Array(data) {
  let binaryString;
  try {
    binaryString = window.atob(data);
  } catch (e) {
    // atob throws a DOMException on malformed input; surface a clear error the caller's global
    // toast can show instead of an opaque decode failure. The backend always emits valid base64,
    // so this is a guard, not an expected path.
    throw new Error("Could not decode the exported file (invalid base64 payload).");
  }
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

export default function downloadBase64File(data, filename, mimeType = "application/pdf") {
  const blob = new Blob([base64ToUint8Array(data)], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = window.document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Without this the blob stays held for the life of the document.
  window.URL.revokeObjectURL(url);
}
